import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type notificationAdminPermissionType = 'notification_admin_view';

export const notificationAdminPermissionMatrix: IPermissionMatrix<notificationAdminPermissionType> = {
  notification_admin_view: [UserRole.admin]
};
